<template>
  <div>
    <div class="columns" v-if="!editMode">
      <b-notification
        type="is-info is-light"
        aria-close-label="Close notification"
      >
        Campurile notate cu * sunt obligatoriu de completat.
      </b-notification>
    </div>
    <ValidationObserver ref="form">
      <div class="columns" v-if="!editMode">
        <div class="column is-4">
          <b-field label="Sablon">
            <b-select
              v-model="selectedTemplate"
              placeholder="Selecteaza un sablon..."
              icon="file-document-outline"
              @input="applyTemplate"
            >
              <option :value="null">-- Fara sablon --</option>
              <option
                v-for="template in templates"
                :value="template"
                :key="template.id"
              >
                {{ template.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div class="columns" v-if="editMode">
        <div v-if="!hasRegistraturaAccess()">
          <div class="column is-narrow">
            <div>
              <b-field label="Nr. Inreg. intern">
                <label
                  >{{ registryEntry.internalRegistrationNumber }}/{{
                    registryEntry.internalRegistrationDate | formatDate
                  }}</label
                >
              </b-field>
            </div>
          </div>
          <div class="column is-narrow">
            <b-field label="Departament">
              <label>{{ departmentName }}</label>
            </b-field>
          </div>
        </div>
        <div v-else>
          <div class="column is-narrow">
            <ValidationProvider
              name="Departament"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Departament *"
                :message="errors[0]"
              >
                <b-dropdown v-model="departmentName" multiple aria-role="list">
                  <template #trigger>
                    <b-button type="is-primary" icon-right="menu-down">
                      Selectat ({{ departmentName }})
                    </b-button>
                  </template>
                  <b-dropdown-item
                    v-for="dep in departments"
                    :value="dep.name"
                    :key="dep.id"
                    aria-role="listitem"
                  >
                    <span>{{ dep.name }}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>
            </ValidationProvider>
          </div>
          <div class="column is narrow">
            <b-field label="Nr. Inreg. intern">
              <label
                >{{ registryEntry.internalRegistrationNumber }}/{{
                  registryEntry.internalRegistrationDate | formatDate
                }}</label
              >
            </b-field>
          </div>
        </div>
      </div>
      <div class="columns" v-else>
        <div v-if="hasRegistraturaAccess()">
          <div class="column is-narrow">
            <ValidationProvider
              name="Departament"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Departament *"
                :message="errors[0]"
              >
                <b-dropdown v-model="departmentName" multiple aria-role="list">
                  <template #trigger>
                    <b-button type="is-primary" icon-right="menu-down">
                      Selectat ({{ departmentName }})
                    </b-button>
                  </template>
                  <b-dropdown-item
                    v-for="dep in departments"
                    :value="dep.name"
                    :key="dep.id"
                    aria-role="listitem"
                  >
                    <span>{{ dep.name }}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>
            </ValidationProvider>
          </div>
          <div class="column is-narrow">
            <ValidationProvider name="Numere rezervate" v-slot="{ errors }">
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Numere rezervate"
                :message="errors[0]"
              >
                <!-- Fara placeholder: optiunea cu valoarea null este cea afisata implicit. -->
                <b-select
                  icon="account"
                  v-model="selectedReservedNumberId"
                  @focus="onFocus()"
                >
                  <option :value="null">- fara numar rezervat -</option>
                  <optgroup
                    v-for="group in reservedNumbersByYear"
                    :key="group.label"
                    :label="group.label"
                  >
                    <option
                      v-for="reservedNumber in group.items"
                      :value="reservedNumber.id"
                      :key="reservedNumber.id"
                    >
                      {{ reservedNumber.number }} ·
                      {{ reservedNumber.registrationDate | formatDate }}
                    </option>
                  </optgroup>
                </b-select>
              </b-field>
            </ValidationProvider>
          </div>
        </div>
        <div v-else>
          <div class="column is-narrow">
            <b-field label="Departament">
              <label>{{ departmentName }}</label>
            </b-field>
          </div>
        </div>
      </div>

      <!-- Informatii document -->
      <div class="section-heading">Informatii document</div>
      <div class="columns">
        <div class="column is-4">
          <ValidationProvider name="Tip document" v-slot="{ errors }">
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              :message="errors[0]"
              label="Tip document"
            >
              <div class="block">
                <b-radio
                  v-model="registryEntry.type"
                  name="name"
                  native-value="Intrare"
                  :disabled="isDisabled"
                >
                  Intrare
                </b-radio>
                <b-radio
                  v-model="registryEntry.type"
                  name="name"
                  native-value="Iesire"
                  :disabled="isDisabled"
                >
                  Iesire
                </b-radio>
              </div>
            </b-field>
          </ValidationProvider>
        </div>
        <div class="column is-4">
          <div class="field">
            <ValidationProvider
              name="Status"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Status"
                :message="errors[0]"
              >
                <b-dropdown v-model="registryEntry.status" aria-role="list">
                  <template #trigger>
                    <b-button type="is-primary" icon-right="menu-down">
                      {{ registryEntry.status }}
                    </b-button>
                  </template>

                  <b-dropdown-item value="Rezolvat" aria-role="listitem">
                    <span>Rezolvat</span>
                  </b-dropdown-item>

                  <b-dropdown-item value="În lucru" aria-role="listitem">
                    <span>În lucru</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-8">
          <ValidationProvider
            name="Continut"
            rules="required"
            v-slot="{ errors }"
          >
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              label="Continut *"
              :message="errors[0]"
            >
              <b-input
                v-model="registryEntry.description"
                type="textarea"
                rows="3"
                required
                :disabled="isDisabled"
              />
            </b-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <ValidationProvider name="Emitent" v-slot="{ errors }">
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              label="Emitent"
              :message="errors[0]"
            >
              <b-input v-model="registryEntry.issuer" :disabled="isDisabled" />
            </b-field>
          </ValidationProvider>
        </div>
        <div class="column is-4">
          <ValidationProvider name="Nr. Inreg. extern" v-slot="{ errors }">
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              label="Nr. Inreg. extern"
              :message="errors[0]"
            >
              <b-input
                :disabled="isDisabled"
                v-model="registryEntry.externalRegistrationNumber"
              />
            </b-field>
          </ValidationProvider>
        </div>
        <div class="column is-4">
          <ValidationProvider name="Data Inreg. extern" v-slot="{ errors }">
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              label="Data Inreg. extern"
              :message="errors[0]"
            >
              <b-datepicker
                :date-parser="parser"
                v-model="registryEntry.externalRegistrationDate"
                locale="ro"
                :disabled="isDisabled"
              >
              </b-datepicker>
            </b-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <ValidationProvider name="Data expiedere" v-slot="{ errors }">
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              label="Data expediere"
              :message="errors[0]"
            >
              <b-datepicker
                :date-parser="parser"
                v-model="registryEntry.dispatchDate"
                locale="ro"
                :disabled="isDisabled"
              >
              </b-datepicker>
            </b-field>
          </ValidationProvider>
        </div>
        <div class="column is-4">
          <ValidationProvider name="Destinatar" v-slot="{ errors }">
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              label="Destinatar"
              :message="errors[0]"
              :disabled="isDisabled"
            >
              <b-input
                :disabled="isDisabled"
                v-model="registryEntry.destination"
              />
            </b-field>
          </ValidationProvider>
        </div>
      </div>
      <!-- Termene -->
      <div class="section-heading">Termene</div>
      <div class="columns">
        <div class="column is-4">
          <ValidationProvider
            name="Nr.zile pentru solutionare"
            v-slot="{ errors }"
          >
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              label="Nr.zile solutionare"
              :message="errors[0]"
            >
              <b-input
                v-model="registryEntry.numberOfDaysToRespond"
                step="1"
                min="0"
                max="10000000"
                type="number"
                :disabled="isDisabled"
                @input="changeNumberOfDaysToRespond"
              />
            </b-field>
          </ValidationProvider>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Data limita solutionare</label>
            <div class="control">
              <b-datepicker
                :date-parser="parser"
                v-model="registryEntry.deadline"
                @input="deadlineSelected()"
                locale="ro"
                :unselectable-days-of-week="[0, 6]"
                :disabled="isDisabled"
              >
              </b-datepicker>
            </div>
          </div>
        </div>
      </div>
      <!-- Solutionare -->
      <div class="section-heading">Solutionare</div>
      <div class="columns">
        <div class="column is-4">
          <ValidationProvider name="Solutionare (pe scurt)" v-slot="{ errors }">
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              label="Solutionare (pe scurt)"
              :message="errors[0]"
            >
              <b-input v-model="registryEntry.responseDescription" />
            </b-field>
          </ValidationProvider>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Data solutionare</label>
            <div class="control">
              <b-datepicker
                :date-parser="parser"
                v-model="registryEntry.responseDate"
                locale="ro"
                :unselectable-days-of-week="[0, 6]"
              >
              </b-datepicker>
            </div>
          </div>
        </div>
      </div>
      <!-- Atasamente -->
      <div class="section-heading">Atasamente</div>
      <div class="columns">
        <div class="column is-8">
          <div v-if="attachmentUris.length" class="mb-3">
            <p class="has-text-weight-semibold mb-2">Documente atasate:</p>
            <div
              v-for="(att, index) in attachmentUris"
              :key="'att-' + index"
              class="is-flex is-align-items-center mb-2"
              style="gap: 0.5rem"
            >
              <b-icon icon="file-document-outline" size="is-small" />
              <a :href="att.URI || att.uri" target="_blank" class="is-flex-grow-1">{{
                att.name || att.fileName
              }}</a>
              <b-button
                size="is-small"
                type="is-danger is-outlined"
                icon-left="delete"
                @click="removeAttachment(index)"
              >
                Sterge
              </b-button>
            </div>
          </div>
          <b-field class="file is-primary">
            <b-upload v-model="newFiles" multiple class="file-label">
              <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Selecteaza fisiere pentru atasare...</span>
              </span>
            </b-upload>
          </b-field>
          <div v-if="newFiles.length" class="mt-2">
            <div
              v-for="(file, index) in newFiles"
              :key="'new-' + index"
              class="is-flex is-align-items-center mb-1"
              style="gap: 0.5rem"
            >
              <b-icon icon="file-outline" size="is-small" />
              <span class="is-flex-grow-1">{{ file.name }}</span>
              <b-button
                size="is-small"
                type="is-danger is-outlined"
                icon-left="delete"
                @click="removeNewFile(index)"
              >
                Sterge
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <div class="columns">
      <div class="column">
        <b-field grouped>
          <div class="control">
            <b-button
              type="is-primary"
              native-type="submit"
              :loading="isUploadingAttachments"
              @click="handleAddRegistryEntry"
              >Salvare</b-button
            >
          </div>
          <div class="control">
            <b-button type="is-danger is-outlined" @click="cancel()"
              >Anulare</b-button
            >
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { rawObject } from "@/helpers/utils";
import { pathOr } from "ramda";
import RegistryEntries from "@/services/registryEntries.service";
import RegistriesService from "@/services/registry.service";
import { accessMixin } from "../../mixins/accessMixin";
import moment from "moment";
import { REGISTRY_TEMPLATES } from "@/config/registryTemplates";
import BlobsService from "@/services/blobs.service";

export default {
  name: "RegistryEntriesAdd",
  mixins: [accessMixin],
  computed: {
    isDisabled() {
      if (this.editMode && !this.hasAdminToRegistry()) {
        return "disabled";
      } else {
        return null;
      }
    },
    // Lista vine ordonata de la API (an descrescator, numar crescator); aici doar se grupeaza.
    reservedNumbersByYear() {
      const groups = [];
      this.reservedNumbers.forEach((reservedNumber) => {
        const label = reservedNumber.year
          ? String(reservedNumber.year)
          : "fara an";
        let group = groups.find((existing) => existing.label === label);
        if (!group) {
          group = { label, items: [] };
          groups.push(group);
        }
        group.items.push(reservedNumber);
      });
      return groups;
    },
  },
  methods: {
    changeNumberOfDaysToRespond(value) {
      this.registryEntry.deadline = new Date(
        moment(this.registryEntry.internalRegistrationDate, "DD-MM-YYYY").add(
          value,
          "days"
        )
      );
    },
    applyTemplate(template) {
      if (!template) return;
      this.registryEntry.type = template.type;
      this.registryEntry.numberOfDaysToRespond = template.numberOfDaysToRespond;
      this.registryEntry.description = template.descriptionPrefix;
      if (this.registryEntry.internalRegistrationDate) {
        this.registryEntry.deadline = new Date(
          moment(this.registryEntry.internalRegistrationDate, "DD-MM-YYYY").add(
            template.numberOfDaysToRespond,
            "days"
          )
        );
      }
      const matchedDept = this.departments.find(
        (d) =>
          d.name.trim().toLowerCase() ===
          template.department.trim().toLowerCase()
      );
      this.departmentName = matchedDept ? [matchedDept.name] : [];
    },
    deadlineSelected() {
      var a = moment(this.registryEntry.deadline).startOf("day");
      var b = moment(this.registryEntry.internalRegistrationDate).startOf(
        "day"
      );

      this.registryEntry.numberOfDaysToRespond = moment(a)
        .startOf("day")
        .diff(moment(b).startOf("day"), "days");
    },
    onFocus() {
      this.getReservedNumbers();
    },
    parser(d) {
      return new Date(Date.parse(d));
    },
    removeAttachment(index) {
      this.attachmentUris.splice(index, 1);
    },
    removeNewFile(index) {
      this.newFiles.splice(index, 1);
    },
    async uploadAttachments() {
      const { handleUploadRegistryEntryAttachment } = BlobsService;
      const attachments = [];
      for (const file of this.newFiles) {
        const response = await handleUploadRegistryEntryAttachment(file);
        if (response && response.data) {
          attachments.push({ name: file.name, fileName: file.name, URI: response.data });
        }
      }
      return attachments;
    },
    // Muta valoarea in fusul local si o serializeaza, fara sa atinga modelul.
    // Valorile care nu sunt Date sunt lasate asa cum sunt, ca sa nu se aplice
    // deplasarea de doua ori la o a doua salvare.
    toApiDate(value) {
      if (!value || !(value instanceof Date)) {
        return value;
      }

      return new Date(
        value.getTime() - value.getTimezoneOffset() * 60000
      ).toJSON();
    },
    buildRegistryEntryPayload() {
      return {
        ...this.registryEntry,
        externalRegistrationDate: this.toApiDate(
          this.registryEntry.externalRegistrationDate
        ),
        internalRegistrationDate: this.toApiDate(
          this.registryEntry.internalRegistrationDate
        ),
        deadline: this.toApiDate(this.registryEntry.deadline),
        responseDate: this.toApiDate(this.registryEntry.responseDate),
        dispatchDate: this.toApiDate(this.registryEntry.dispatchDate),
      };
    },
    async handleAddRegistryEntry() {
      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          return;
        }

        if (this.newFiles.length > 0) {
          this.isUploadingAttachments = true;
          const newUris = await this.uploadAttachments();
          this.attachmentUris = [...this.attachmentUris, ...newUris];
          this.newFiles = [];
          this.isUploadingAttachments = false;
        }
        this.registryEntry.attachments = [...this.attachmentUris];

        // Doar registratura schimba departamentele unei inregistrari existente (SEC-17).
        // Ceilalti vad doar eticheta si trimit inapoi departamentul salvat: lista lor contine
        // doar propriul departament, care ar muta inregistrarea la alt compartiment.
        const keepsStoredDepartment =
          this.editMode && !this.hasRegistraturaAccess();
        if (!keepsStoredDepartment) {
          if (this.departments.length == 1) {
            this.registryEntry.department = this.departments[0].name;
          } else {
            this.registryEntry.department = this.departmentName.join(";");
          }
        }
        this.registryEntry.username = this.$store.state.userName;
        this.registryEntry.registryId = this.registryId;

        // Conversia se face intr-o copie, nu peste model. Daca serverul refuza salvarea
        // (de exemplu numarul rezervat nu mai e liber), operatorul ramane in formular si
        // trebuie sa poata salva din nou - iar campurile de data trebuie sa fie in
        // continuare obiecte Date, nu text deja convertit.
        const payload = this.buildRegistryEntryPayload();

        if (this.editMode) {
          this.$emit("handleEditRegistryEntry", rawObject(payload));
        } else {
          // Serverul ia numarul, data si anul din rezervarea identificata prin Id;
          // fara rezervare, aloca numarul urmator si pune ora salvarii.
          payload.reservedNumberId = this.selectedReservedNumberId;
          this.$emit("handleAddRegistryEntry", rawObject(payload));
        }
      });
    },
    async getDepartments() {
      const { getAllDepartments } = RegistryEntries;
      getAllDepartments().then((response) => {
        const { data } = response;
        this.departments = data;
        // La editare, departamentul afisat vine din inregistrare, iar lista poate sosi dupa ea.
        if (this.departments.length == 1 && !this.editMode) {
          this.departmentName = this.departments[0].name;
        }
      });
    },
    async getReservedNumbers() {
      // Lista afisata ramane pana soseste cea noua: golirea inainte de cerere
      // facea optiunile sa dispara la fiecare focus.
      const { getReservedNumbers } = RegistriesService;
      const response = await getReservedNumbers(this.registryId);
      const data = pathOr(null, ["data"], response);
      if (Array.isArray(data)) {
        this.reservedNumbers = data;
      }
    },
    // Apelata din RegistryEntry.vue cand serverul refuza rezervarea aleasa.
    resetReservedNumberSelection() {
      this.selectedReservedNumberId = null;
      return this.getReservedNumbers();
    },
    async getRegistryEntry(id) {
      const { handleGetRegistryEntry } = RegistryEntries;
      const response = await handleGetRegistryEntry(id);
      const { data } = response;
      return data;
    },
    async getRegistryEntries(registryId) {
      const { getRegistryEntries } = RegistriesService;
      const response = await getRegistryEntries(registryId);
      const { data } = response;
      return data;
    },
    cancel() {
      this.$router.push({ path: "/RegistryEntries" });
    },
  },
  data() {
    return {
      editMode: false,
      id: 0,
      selectedReservedNumberId: null,
      departmentName: [],
      reservedNumbers: [],
      departments: [],
      registryId: 0,
      selectedTemplate: null,
      templates: REGISTRY_TEMPLATES,
      newFiles: [],
      attachmentUris: [],
      isUploadingAttachments: false,
      registryEntry: {
        internalRegistrationNumber: 0,
        internalRegistrationDate: null,
        externalRegistrationNumber: null,
        externalRegistrationDate: null,
        registryId: 0,
        issuer: null,
        description: null,
        department: null,
        dispatchDate: null,
        destination: null,
        status: "În lucru",
        type: null,
        numberOfDaysToRespond: 0,
        deadline: null,
        responseDescription: null,
        responseDate: null,
        attachments: [],
      },
    };
  },
  created() {
    const registryId = parseInt(
      pathOr(null, ["params", "registryId"], this?.$route)
    );

    this.registryId = registryId;
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    this.id = id;

    this.getDepartments();
    this.getReservedNumbers();

    if (this.id) {
      this.editMode = true;
      this.getRegistryEntry(id).then((response) => {
        this.registryEntry = response;
        if (this.registryEntry.externalRegistrationDate) {
          this.registryEntry.externalRegistrationDate = new Date(
            this.registryEntry.externalRegistrationDate
          );
        }
        if (this.registryEntry.dispatchDate) {
          this.registryEntry.dispatchDate = new Date(
            this.registryEntry.dispatchDate
          );
        }

        if (this.registryEntry.responseDate) {
          this.registryEntry.responseDate = new Date(
            this.registryEntry.responseDate
          );
        }

        if (this.registryEntry.deadline) {
          this.registryEntry.deadline = new Date(this.registryEntry.deadline);
        }

        if (this.registryEntry.internalRegistrationDate) {
          this.registryEntry.internalRegistrationDate = new Date(
            this.registryEntry.internalRegistrationDate
          );
        }
        this.departmentName = this.registryEntry.department.split(";");

        this.departmentName.forEach(function (item, index) {
          item = item.replace(/^\s+|\s+$/gm, "");
        });
        if (this.departmentName.length === 1) {
          this.departmentName = [this.departmentName[0]];
        }

        if (
          this.registryEntry.attachments &&
          this.registryEntry.attachments.length
        ) {
          this.attachmentUris = this.registryEntry.attachments.map((a) =>
            typeof a === "string"
              ? { name: a.split("/").pop(), fileName: a.split("/").pop(), URI: a }
              : a
          );
        }
      });
    }
    this.registryEntry.internalRegistrationDate = new Date();
    this.registryEntry.deadline = new Date(
      moment(this.registryEntry.internalRegistrationDate, "DD-MM-YYYY").add(
        this.registryEntry.numberOfDaysToRespond,
        "days"
      )
    );
  },
};
</script>

<style scoped>
.section-heading {
  font-size: 0.95rem;
  font-weight: 600;
  color: #4a4a4a;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-top: 1.25rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 2px solid #e8e8e8;
}
</style>
